var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 34.166C7.73894 34.166 7.12094 33.909 6.60694 33.395C6.09294 32.881 5.83594 32.263 5.83594 31.541V25.166H7.91994V31.541C7.91994 31.6797 7.97527 31.8047 8.08594 31.916C8.19727 32.0267 8.32227 32.082 8.46094 32.082H14.8359V34.166H8.46094ZM25.1699 34.166V32.082H31.5449C31.6836 32.082 31.8086 32.0267 31.9199 31.916C32.0306 31.8047 32.0859 31.6797 32.0859 31.541V25.166H34.1699V31.541C34.1699 32.263 33.9129 32.881 33.3989 33.395C32.8849 33.909 32.2669 34.166 31.5449 34.166H25.1699ZM5.83594 14.832V8.45703C5.83594 7.73503 6.09294 7.11703 6.60694 6.60303C7.12094 6.08903 7.73894 5.83203 8.46094 5.83203H14.8359V7.91603H8.46094C8.32227 7.91603 8.19727 7.97136 8.08594 8.08203C7.97527 8.19336 7.91994 8.31836 7.91994 8.45703V14.832H5.83594ZM32.0859 14.832V8.45703C32.0859 8.31836 32.0306 8.19336 31.9199 8.08203C31.8086 7.97136 31.6836 7.91603 31.5449 7.91603H25.1699V5.83203H31.5449C32.2669 5.83203 32.8849 6.08903 33.3989 6.60303C33.9129 7.11703 34.1699 7.73503 34.1699 8.45703V14.832H32.0859Z",
    fill: "#587E85"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.458C18 25.458 16.1943 24.9303 14.583 23.875C12.9723 22.819 11.778 21.444 11 19.75C11.778 18.0553 12.9653 16.6733 14.562 15.604C16.1593 14.5347 17.972 14 20 14C22 14 23.8057 14.5347 25.417 15.604C27.0277 16.6733 28.222 18.0553 29 19.75C28.222 21.444 27.0347 22.819 25.438 23.875C23.8407 24.9303 22.028 25.458 20 25.458ZM20 23.708C21.4447 23.708 22.785 23.3607 24.021 22.666C25.257 21.972 26.264 21 27.042 19.75C26.264 18.5 25.257 17.5277 24.021 16.833C22.785 16.1383 21.4447 15.791 20 15.791C18.5553 15.791 17.215 16.1383 15.979 16.833C14.743 17.5277 13.736 18.5 12.958 19.75C13.736 21 14.743 21.972 15.979 22.666C17.215 23.3607 18.5553 23.708 20 23.708ZM20 21.708C20.5553 21.708 21.0207 21.5137 21.396 21.125C21.7707 20.7357 21.958 20.2773 21.958 19.75C21.958 19.194 21.7637 18.7287 21.375 18.354C20.9863 17.9787 20.528 17.791 20 17.791C19.4447 17.791 18.9793 17.9857 18.604 18.375C18.2293 18.7637 18.042 19.222 18.042 19.75C18.042 20.3053 18.2363 20.7703 18.625 21.145C19.0137 21.5203 19.472 21.708 20 21.708Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo2);
export default __webpack_public_path__ + "static/media/demo2.4eebcc9d881f224695dbc2dbd9dd5f5d.svg";
export { ForwardRef as ReactComponent };